import { DateFormat } from '@youhelp/common/const/date';

export const DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT = 'yyyy.MM.dd';
export const DATE_TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT = DateFormat.DateTimePostgreSQL;
